import React from 'react';
import { ImageFile } from '~/data/types/images';

const SendImage: React.FC<ImageFile> = ({
  className,
  style,
  Component = 'svg',
}) => {
  return (
    <Component
      width="150"
      height="52"
      viewBox="0 0 150 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M56.192 44.0765C80.9804 51.091 89.1779 13.8083 112.442 13.8083C141.484 13.8083 114.862 44.9245 114.862 32.1323C114.862 22.3949 188.158 62.1546 204.215 16.3797M56.192 44.0765L49.8027 17.9017M56.192 44.0765L46.1656 25.5804M56.192 44.0765L37.9993 39.0326M49.8027 17.9017L59.8016 2.07862C59.9231 1.88633 59.703 1.63487 59.494 1.72725L2 27.1442M49.8027 17.9017L2 27.1442M2 27.1442L31.246 49.655C31.358 49.7412 31.5122 49.7187 31.5805 49.6063L37.9993 39.0326M2 27.1442L46.1656 25.5804M46.1656 25.5804L37.9993 39.0326"
        stroke="#00D6D1"
        stroke-width="2.76589"
        stroke-linejoin="round"
      />
    </Component>
  );
};

export default SendImage;
